import { Box, Modal, CircularProgress, LinearProgress } from "@mui/material";

type LoaderProps = {
  isLoad?: boolean;
  isLinear?: boolean;
};

const Loader = ({ isLoad = false, isLinear = false }: LoaderProps) => {
  if (!isLoad) return null;

  return (
    <Box>
      {isLinear ? (
        <Box
          sx={{
            position: "fixed",
            top: 70, // Just below the TopBar height
            left: 0,
            width: "100%",
            zIndex: 1100,
          }}
        >
          <LinearProgress
            sx={{
              height: 4,
              backgroundColor: "rgba(21, 29, 48, 0.1)",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#151D30",
              },
            }}
          />
        </Box>
      ) : (
        <Modal
          open
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: "rgba(21, 29, 48, 0.25)",
                backdropFilter: "blur(3px)",
              },
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              outline: "none",
            }}
          >
            <CircularProgress
              sx={{
                color: "#151D30",
              }}
              size={50}
            />
          </Box>
        </Modal>
      )}
    </Box>
  );
};

export default Loader;
